import React from "react";
import Icon from "../../atoms/Icon/icon.jsx";
import { isMobile } from "../../../../helpers/Mobile";
import styles from "./MainApp.organisms.LocationPanel.module.scss";
import i18n from "i18n";

const LocationPanel = ({ title, type, items, handleAdd, handleClick }) => {
  return (
    <div className={styles["location-panel"]}>
      <div className={styles["location-panel-header"]}>
        <h1 className={styles["location-panel-header-title"]}>
          {title} ({items.length})
        </h1>
        {handleAdd && (
          <p className={styles["location-panel-add-button"]} onClick={handleAdd}>
            <Icon name="add" heigth={12} width={12} fill={"#3C7AF5"} />
            {i18n.t("add")} {type === "zona" ? i18n.t("zone") : type}
          </p>
        )}
      </div>
      <div className={styles["location-panel-items"]}>
        {items &&
          items.length > 0 &&
          items.map((item) => {
            return (
              <div
                className={styles["location-panel-item"]}
                key={item.id}
                onClick={() => handleClick(item.id, type)}
              >
                <div className={styles["location-panel-item-name"]}>{item.name}</div>
                <div className={styles["location-panel-icon"]}>
                  <Icon
                    name="chevron-right"
                    heigth={isMobile ? 5 : 10}
                    width={isMobile ? 5 : 10}
                    fill={"#3C7AF5"}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default LocationPanel;
